import {
	AfterViewInit,
	Component,
	Input,
	Output,
	ViewEncapsulation,
	EventEmitter,
	OnDestroy,
} from '@angular/core';
import suneditor from 'suneditor';
import plugins from 'suneditor/src/plugins';

@Component({
	selector: 'fn-text-editor',
	templateUrl: 'fn-text-editor.component.html',
	styleUrls: ['./fn-text-editor.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnTextEditorComponent implements AfterViewInit, OnDestroy {
	@Input() id: string;
	@Input() containerId?: string | HTMLElement;
	@Input() width?: string;
	@Input() minWidth?: string;
	@Input() maxWidth?: string;
	@Input() height?: string;
	@Input() minHeight?: string;
	@Input() maxHeight?: string;
	@Input() textValue: string;
	@Output() formattedValue: EventEmitter<any> = new EventEmitter();
	@Input() userButtonList: Array<string>;
	private editor: any;
	private defaultList: Array<string> = [
		'font',
		'fontSize',
		'formatBlock',
		'bold',
		'underline',
		'italic',
		'strike',
		'subscript',
		'superscript',
		'fontColor',
		'outdent',
		'indent',
		'align',
		'horizontalRule',
		'list',
		'link',
	];
	constructor() {}
	ngAfterViewInit() {
		const buttonList = this.userButtonList
			? this.defaultList.concat(this.userButtonList)
			: this.defaultList;
		const toolbarContainers: HTMLElement = this.containerId
			? document.querySelector(`#${this.containerId}`)
			: null;
		this.textValue = this.textValue || '';
		this.editor = suneditor.create(this.id, {
			toolbarContainer: toolbarContainers,
			width: this.width || '100%',
			minWidth: this.minWidth || null,
			maxWidth: this.maxWidth || null,
			height: this.height || 'auto',
			minHeight: this.minHeight || null,
			maxHeight: this.maxHeight || null,
			plugins: plugins,
			buttonList: [buttonList],
		});
		this.editor.insertHTML(this.textValue, true, true);

		this.editor.onBlur = (e:any, core:any) => {
			// this.formattedValue.emit(core.getContents(true));
		};
		this.editor.onChange = (contents:any, core:any) => {
			this.formattedValue.emit(contents);
		};
	}

	ngOnDestroy() {
		this.editor.destroy();
	}
}
